@if (_costCenter && sapform) {
  <div>
    <p class="top">
      Enter individual codes, in their entirety. All field are require unless
      otherwise stated.
    </p>
    <form class="row" [formGroup]="sapform" (ngSubmit)="verifySap()">
      <div class="col-12">
        <div class="input-group full-width">
          <label for="description"
            >Description <span class="lowercase">(Required)</span>
            @if (
              sapform.get('description').touched &&
              sapform.get('description').hasError('required')
            ) {
              <small class="text-danger">Description is required</small>
            }
          </label>
          <input
            [formControl]="description"
            type="text"
            name="description"
            id="description"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6 pe-1">
        <div class="input-group">
          <label for="companycode"
            >Company Code <span class="lowercase">(4 Digits)</span>
            @if (
              sapform.get('companycode').touched &&
              sapform.get('companycode').hasError('required')
            ) {
              <small class="text-danger">Company Code is required</small>
            }
            @if (
              sapform.get('companycode').touched &&
              sapform.get('companycode').hasError('pattern')
            ) {
              <small class="text-danger"
                >Company Code should be of 4 digits</small
              >
            }
          </label>
          <input
            [formControl]="companycode"
            type="text"
            digitOnly
            name="companycode"
            id="companycode"
            maxlength="4"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="input-group">
          <label for="business-area"
            >Business Area <span class="lowercase">(4 Digits)</span>
            @if (
              sapform.get('businessarea').touched &&
              sapform.get('businessarea').hasError('required')
            ) {
              <small class="text-danger">Business Area Code is required</small>
            }
            @if (
              sapform.get('businessarea').touched &&
              sapform.get('businessarea').hasError('pattern')
            ) {
              <small class="text-danger"
                >Business Area Code should be of 4 digits</small
              >
            }
          </label>
          <input
            [formControl]="businessarea"
            type="text"
            digitOnly
            name="businessarea"
            id="business-area"
            maxlength="4"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6 pe-1">
        <div class="input-group">
          <label for="sapaccountnumber"
            >Cost Element <span class="lowercase">(6 Digits)</span>
            @if (
              sapform.get('sapaccountnumber').touched &&
              sapform.get('sapaccountnumber').hasError('required')
            ) {
              <small class="text-danger">Cost Element is required</small>
            }
            @if (
              sapform.get('sapaccountnumber').touched &&
              sapform.get('sapaccountnumber').hasError('pattern')
            ) {
              <small class="text-danger"
                >Cost Element should be of 6 digits</small
              >
            }
          </label>
          <input
            [formControl]="sapaccountnumber"
            type="text"
            digitOnly
            name="sapaccountnumber"
            id="sapaccountnumber"
            maxlength="6"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="input-group">
          <label for="costcenter"
            >Cost Center <span class="lowercase">(10 Digits)</span>
            @if (
              sapform.get('costcenter').touched &&
              sapform.get('costcenter').hasError('required')
            ) {
              <small class="text-danger">Cost Center is required</small>
            }
            @if (
              sapform.get('costcenter').touched &&
              sapform.get('costcenter').hasError('pattern')
            ) {
              <small class="text-danger"
                >Cost Center should be of 10 digits</small
              >
            }
          </label>
          <input
            [formControl]="costcenterId"
            type="text"
            digitOnly
            name="costcenter"
            id="costcenter"
            maxlength="10"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6 pe-1">
        <div class="input-group">
          <label for="internalordernumber"
            >Internal Order # <span class="lowercase">(Optional)</span>
            @if (
              sapform.get('internalordernumber').touched &&
              sapform.get('internalordernumber').hasError('required')
            ) {
              <small class="text-danger"
                >Internal Order Number is required</small
              >
            }
            @if (
              sapform.get('internalordernumber').touched &&
              sapform.get('internalordernumber').hasError('pattern')
            ) {
              <small class="text-danger"
                >Internal Order Number should be of 6 digits starting with
                0</small
              >
            }
          </label>
          <input
            [formControl]="internalordernumber"
            type="text"
            name="internalordernumber"
            id="internalordernumber"
          />
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="input-group">
          <label for="allocation"
            >Allocation
            <span class="lowercase">(Optional)</span>
            &nbsp;
            @if (
              sapform.get('allocation').touched &&
              sapform.get('allocation').hasError('maxlength')
            ) {
              <small class="text-danger">Up to 25 symbols are allowed</small>
            }
          </label>
          <input
            [formControl]="allocation"
            type="text"
            name="allocation"
            id="allocation"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="input-group full-width">
          <label for="employeeId"
            >DOA Information <span class="lowercase">(Required)</span></label
          >
          <ng-select
            id="employeeId"
            class="select__employee"
            [items]="employeeSearchResults | async"
            bindValue="employee_id"
            [placeholder]="employeeSearchPlaceholder"
            [searchable]="true"
            [loading]="employeeSearchLoading"
            [typeahead]="employeeSearchSubject"
            (change)="selectEmployee($event)"
            dropdownPosition="top"
            [clearable]="false"
          >
            <ng-template ng-label-tmp let-item="item">
              #{{ item.employee_id }} - {{ item.first_name }}
              {{ item.last_name }}
            </ng-template>
            <ng-template ng-header-tmp>
              Search Employee by ID or Name
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              #{{ item.employee_id }} - {{ item.first_name }}
              {{ item.last_name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      @if (invalidCostCenterMessage) {
        <div class="col-12">
          <p
            class="text-danger text-center invalid-cost-center font-5 uppercase"
          >
            {{ invalidCostCenterMessage }}
          </p>
        </div>
      }
      <div class="col-12 text-align-center">
        <strong>SAP NUMBER:</strong> {{ sapLongAccount }}
      </div>
      @if (!isVerified) {
        <button
          [disabled]="!canVerify"
          class="btn btn-primary verify-sap btn-progress"
          type="submit"
          [ngClass]="{ performing: inProgress }"
        >
          <i class="fal fa-sync"></i>
          Verify Information
        </button>
      }
    </form>
  </div>
}
